import React from 'react'
import { useSelector } from "react-redux"
import TwitterIcon from '../icons/TwitterIcon'

export function SocialMediaAccounts() {
  const config = useSelector(x => x.radioReducer.config)
  return (
    <ul className="social-list">
      <li>
        <a
          href={config.NextSocialButonUrl}
          rel="noopener noreferrer"
          target="_blank"
          className="social-link next-social-link"
        >
          <span class="icon icon-next-social"></span>
        </a>
      </li>
      <li>
        <a
          href={config.FacebookUrl}
          rel="noopener noreferrer"
          target="_blank"
          className="social-link"
        >
          <span class="icon icon-circle-facebook"></span>
        </a>
      </li>
      <li className='social-tw'>
          <a
            href={config.TwitterUrl}
            rel="noopener noreferrer"
            target="_blank"
            className="social-link"
          >
            <span class="icon icon-x-twitter"></span>
            
          </a>
      </li>
      <li>
          <a
            href={config.InstagramUrl}
            rel="noopener noreferrer"
            target="_blank"
            className="social-link"
          >
            <span class="icon icon-instagram"></span>
          </a>
      </li>
      <li>
        <a
          href={config.YoutubeUrl}
          rel="noopener noreferrer"
          target="_blank"
          className="social-link"
        >
           <span class="icon icon-youtube"></span>
        </a>
      </li>
    </ul>
  )
}